/* @flow */

import { combineReducers } from 'redux';
import Immutable from 'immutable';
import {
  FETCH_DEPLOYMENTS,
  FETCH_DEPLOYMENTS_SUCCESS,
  FETCH_DEPLOYMENTS_FAILURE,
  DEPLOY,
  DEPLOY_SUCCESS,
  DEPLOY_FAILURE,
} from 'catalog/actions/deployments';

const items = (state = Immutable.Map(), action) => {
  switch (action.type) {
    case FETCH_DEPLOYMENTS_SUCCESS:
      return state.merge(Immutable.Map(action.response.entities.deployments));
    case DEPLOY_SUCCESS:
      const removeProduction = d => ({
        ...d,
        inProduction: false,
      });

      // Cleaning production state then merge
      return state
        .map(removeProduction)
        .merge(Immutable.Map(action.response.entities.deployments));
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_DEPLOYMENTS:
      return true;
    case FETCH_DEPLOYMENTS_SUCCESS:
    case FETCH_DEPLOYMENTS_FAILURE:
      return false;
    default:
      return state;
  }
};

const isFetched = (state = false, action) => {
  switch (action.type) {
    case FETCH_DEPLOYMENTS_SUCCESS:
    case FETCH_DEPLOYMENTS_FAILURE:
      return true;
    default:
      return state;
  }
};

const isDeploying = (state = false, action) => {
  switch (action.type) {
    case DEPLOY:
      return true;
    case DEPLOY_SUCCESS:
    case DEPLOY_FAILURE:
      return false;
    default:
      return state;
  }
};

const deploymentError = (state = null, action) => {
  switch (action.type) {
    case DEPLOY_FAILURE:
      return action.error;
    default:
      return state;
  }
};

export default combineReducers({
  items,
  isFetching,
  isFetched,
  isDeploying,
  deploymentError,
});

export const getDeployments = state =>
  state.deployments.items
    .sortBy(d => d.deployedAt)
    .reverse()
    .toArray();

export const getIsFetching = state => state.deployments.isFetching;
export const getIsFetched = state => state.deployments.isFetched;
export const getIsDeploying = state => state.deployments.isDeploying;
export const getDeploymentError = state => state.deployments.deploymentError;



// WEBPACK FOOTER //
// ./src/modules/catalog/reducers/deployments.js